import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SHOWS = [
  {
    id: "phantom-opera",
    season: "AUTUMN 2026",
    numeral: "II",
    title: "The Phantom Opera",
    copy: "A haunted score, a locked dressing room, and a soprano who never quite left the building.",
    wide: true,
  },
  {
    id: "alchemists-vault",
    season: "WINTER 2026",
    numeral: "III",
    title: "The Alchemist's Vault",
    copy: "Decode a dead man's final formula before the last candle burns down.",
    wide: false,
  },
  {
    id: "midnight-botanical",
    season: "SPRING 2027",
    numeral: "IV",
    title: "Midnight Botanical",
    copy: "A greenhouse that flowers once a century. You are invited to the blooming.",
    wide: false,
  },
];

export const SeasonalShows = ({ onNotify }) => (
  <section
    id="seasons"
    data-testid="seasons-section"
    className="border-t border-gold/10 bg-surface/40 py-24 sm:py-36"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-12">
      <Reveal>
        <p className="font-cinzel text-[11px] tracking-[0.45em] text-gold/80">
          FUTURE EPISODES
        </p>
        <h2 className="mt-6 max-w-2xl font-serif text-3xl font-light text-cream sm:text-5xl">
          The Séance is only <em className="italic text-gold">the first episode.</em>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-sand">
          New episodes arrive with the turning of the year. Join the priority list
          for any of them and be written into its ledger before the general release.
        </p>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-12">
        {SHOWS.map((show, i) => (
          <Reveal
            key={show.id}
            delay={i * 0.1}
            className={show.wide ? "md:col-span-7" : "md:col-span-5"}
          >
            <div
              data-testid={`show-card-${show.id}`}
              className="group flex h-full flex-col justify-between border border-gold/15 bg-obsidian/60 p-10 transition-all duration-500 hover:border-gold/40 hover:shadow-[inset_0_0_60px_rgba(226,177,93,0.05)]"
            >
              <div>
                <div className="flex items-center justify-between">
                  <p className="font-cinzel text-[10px] tracking-[0.35em] text-gold/70">
                    EPISODE {show.numeral} — {show.season}
                  </p>
                </div>
                <h3 className="mt-6 font-serif text-3xl font-light text-cream transition-colors duration-500 group-hover:text-gold-glow sm:text-4xl">
                  {show.title}
                </h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-sand">
                  {show.copy}
                </p>
              </div>
              <button
                data-testid={`notify-button-${show.id}`}
                onClick={() => {
                  onNotify(show.id);
                  scrollToId("#join");
                }}
                className="mt-10 flex w-fit items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:text-gold-glow"
              >
                Join the priority list
                <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1.5" />
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
